/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    customerId?: string;
    /**
     * Name of the customer that owns this tenant
     * @type {string}
     * @memberof TenantDto
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    organizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    enrollmentStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof TenantDto
     */
    enrollmentDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    adminUserId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantDto
     */
    settings?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof TenantDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TenantDto
     */
    updatedAt?: Date;
    /**
     * Scheduled decommission date (if tenant is scheduled for deletion with grace period)
     * @type {Date}
     * @memberof TenantDto
     */
    scheduledDecommissionAt?: Date;
    /**
     * Date when tenant was decommissioned
     * @type {Date}
     * @memberof TenantDto
     */
    decommissionedAt?: Date;
    /**
     * Computed decommission status: 'active', 'scheduled_for_decommission', or 'decommissioned'
     * @type {string}
     * @memberof TenantDto
     */
    decommissionStatus?: string;
    /**
     * Days until scheduled decommission (null if not scheduled or already decommissioned)
     * @type {number}
     * @memberof TenantDto
     */
    daysUntilScheduledDecommission?: number;
    /**
     * Whether tenant is on legal hold (blocks decommission and purge)
     * @type {boolean}
     * @memberof TenantDto
     */
    legalHold?: boolean;
    /**
     * Date when tenant will be permanently purged (null if legal hold or not decommissioned)
     * @type {Date}
     * @memberof TenantDto
     */
    purgeAfter?: Date;
    /**
     * Custom retention period in days (null if using default)
     * @type {number}
     * @memberof TenantDto
     */
    retentionOverrideDays?: number;
    /**
     * Custom retention period end date (null if using days-based retention)
     * @type {Date}
     * @memberof TenantDto
     */
    retentionOverrideUntil?: Date;
    /**
     * Days until permanent purge (null if legal hold or not decommissioned)
     * @type {number}
     * @memberof TenantDto
     */
    daysUntilPurge?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDto
     */
    _protected?: boolean;
}

/**
 * Check if a given object implements the TenantDto interface.
 */
export function instanceOfTenantDto(value: object): value is TenantDto {
    return true;
}

export function TenantDtoFromJSON(json: any): TenantDto {
    return TenantDtoFromJSONTyped(json, false);
}

export function TenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'status': json['status'] == null ? undefined : json['status'],
        'enrollmentStatus': json['enrollmentStatus'] == null ? undefined : json['enrollmentStatus'],
        'enrollmentDate': json['enrollmentDate'] == null ? undefined : (new Date(json['enrollmentDate'])),
        'adminUserId': json['adminUserId'] == null ? undefined : json['adminUserId'],
        'settings': json['settings'] == null ? undefined : json['settings'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'scheduledDecommissionAt': json['scheduledDecommissionAt'] == null ? undefined : (new Date(json['scheduledDecommissionAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'decommissionStatus': json['decommissionStatus'] == null ? undefined : json['decommissionStatus'],
        'daysUntilScheduledDecommission': json['daysUntilScheduledDecommission'] == null ? undefined : json['daysUntilScheduledDecommission'],
        'legalHold': json['legalHold'] == null ? undefined : json['legalHold'],
        'purgeAfter': json['purgeAfter'] == null ? undefined : (new Date(json['purgeAfter'])),
        'retentionOverrideDays': json['retentionOverrideDays'] == null ? undefined : json['retentionOverrideDays'],
        'retentionOverrideUntil': json['retentionOverrideUntil'] == null ? undefined : (new Date(json['retentionOverrideUntil'])),
        'daysUntilPurge': json['daysUntilPurge'] == null ? undefined : json['daysUntilPurge'],
        '_protected': json['protected'] == null ? undefined : json['protected'],
    };
}

export function TenantDtoToJSON(json: any): TenantDto {
    return TenantDtoToJSONTyped(json, false);
}

export function TenantDtoToJSONTyped(value?: TenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'organizationName': value['organizationName'],
        'status': value['status'],
        'enrollmentStatus': value['enrollmentStatus'],
        'enrollmentDate': value['enrollmentDate'] == null ? undefined : ((value['enrollmentDate']).toISOString()),
        'adminUserId': value['adminUserId'],
        'settings': value['settings'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'scheduledDecommissionAt': value['scheduledDecommissionAt'] == null ? undefined : ((value['scheduledDecommissionAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'decommissionStatus': value['decommissionStatus'],
        'daysUntilScheduledDecommission': value['daysUntilScheduledDecommission'],
        'legalHold': value['legalHold'],
        'purgeAfter': value['purgeAfter'] == null ? undefined : ((value['purgeAfter']).toISOString()),
        'retentionOverrideDays': value['retentionOverrideDays'],
        'retentionOverrideUntil': value['retentionOverrideUntil'] == null ? undefined : ((value['retentionOverrideUntil']).toISOString()),
        'daysUntilPurge': value['daysUntilPurge'],
        'protected': value['_protected'],
    };
}

